<template>
    <div>
        <div class="mt-8 flex justify-center grid grid-cols-1 sm:grid-cols-2 gap-4">
            <a class="bg-blue-700 hover:bg-blue-800 text-white py-5 sm:py-2 rounded-md flex items-center"
                :href="loginWithSocial('facebook')">
                <span class="sr-only">Facebook</span>
                <svg class="h-6 w-6 mx-auto" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill-rule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clip-rule="evenodd" />
                </svg>
            </a>


            <a class="bg-blue-500 hover:bg-blue-600 text-white py-5 sm:py-2 rounded-md flex items-center shadow-md"
                :href="loginWithSocial('twitter')">
                <span class="sr-only">Twitter</span>
                <svg class="h-6 w-6 mx-auto" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                        d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
            </a>



            <!--   <a href="#" class="bg-strava-base hover:bg-strava-hover text-white py-5 sm:py-2 rounded-md" @click="loginWithSocial('strava')">
                <span class="sr-only">Strava</span>
                <svg class="h-6 w-6 mx-auto" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"/>
                </svg>
            </a> -->
        </div>
    </div>
</template>
<script>
export default {
    name: 'social.login',
    props:[
        'type'
    ],
    data() {
        return {
            socialChecking: false,
            loginInterval: false,
            loginPopup: false,
        }
    },
    methods: {
        loginWithSocial(type) {
            return this.baseUrl + '/social_login/' + type;
        },
        checkLogin(e) {

            const self = this;

            if (!self.socialChecking) {
                self.socialChecking = true;

                Vue.axios.get('client/loggedIn')
                    .then((loggedIn) => {
                        self.socialChecking = false;

                        if (loggedIn) {
                            clearInterval(self.loginInterval);
                            window.location.href = (self.baseUrl + '/dashboard');
                        }
                    })
            }
        },
    }
}
</script>